import React from 'react'
import PropTypes from 'prop-types'
import { LoginButton } from 'react-facebook'
import { IconFacebook } from '../../Icons/IconFacebook'

function LoginFacebookButtonV2(props) {
    const { state, onSucess, onError, handleRemove , t, isModal} = props

    const handleFacebookResponse = (res) => {
        console.log('handleFacebookResponse=>res=', res)
        onSucess(res?.tokenDetail?.accessToken)
    }
    const handleFacebookError = (res) => {
        console.log('handleFacebookResponse=>res=', res)
    }
    return (
        !isModal ? <div className="flex flex-col justify-center  items-center gap-5">
            <IconFacebook className="w-[20px]" />
            {
                !state && <LoginButton
                    scope="email"
                    onCompleted={handleFacebookResponse}
                    onError={handleFacebookError}
                    autoLoad={false}
                    className={`border border-solid border-black/[0.1] rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] text-center text-black text-xs connect-facebook`}
                >{t('Connect')}</LoginButton>
            }
            {
                state && <button className="border border-solid border-black/[0.1]
                 rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] text-center 
                 text-suzu-error text-xs" onClick={() => handleRemove()}>{t('title.disconnect')}</button>
            }
        </div> : <div className="flex flex-row justify-start  items-center gap-[10px] lg:gap-[15px]">
            <IconFacebook className="w-[20px]" />
            <LoginButton
                scope="email"
                onCompleted={handleFacebookResponse}
                onError={handleFacebookError}
                autoLoad={false}
                className={` bg-white h-[30px] px-1 text-center text-black text-xs connect-facebook`}
            ><span className="text-black text-[14px]">
            {t("title_connect_facebook_account")}
          </span></LoginButton>
        </div>
    )
}

LoginFacebookButtonV2.propTypes = {
    state: PropTypes.string,
    onSucess: PropTypes.func,
    onError: PropTypes.func,
    handleRemove: PropTypes.func
}

export default LoginFacebookButtonV2

